import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Loading from './Loading';

const useStyles = makeStyles(() => ({
   BoxLight: {
      background: 'linear-gradient(to bottom, #ec008c, #fc6767)',
   },
}));

const LoadingFullScreen = () => {
   const classes = useStyles();
   return (
      <Box
         display='flex'
         flexDirection='column'
         justifyContent='center'
         alignContent='center'
         alignItems='center'
         height='100vh'
         textAlign='center'
         className={classes.BoxLight}
      >
         <Loading />
      </Box>
   );
};
export default LoadingFullScreen;
